import {Context} from "@nuxt/types";

export default function hasPermission(serverPermissionName: any): (params: Context) => void {
  return ({$auth, redirect}): void => {
    if (!$auth.hasAllPermissions(serverPermissionName)) {
      redirect("/user/login");
    }
  };
}
